import { render, staticRenderFns } from "./PdfElement.vue?vue&type=template&id=75a4ffd2&scoped=true&"
import script from "./PdfElement.vue?vue&type=script&lang=ts&"
export * from "./PdfElement.vue?vue&type=script&lang=ts&"
import style0 from "./PdfElement.vue?vue&type=style&index=0&id=75a4ffd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a4ffd2",
  null
  
)

export default component.exports